export function getCookie(name) {
	const cookiePrefix = name + '=';
	const cookies = document.cookie.split(';');
	for (let i = 0; i < cookies.length; i++) {
		const cookie = cookies[i].trim();
		if (cookie.indexOf(cookiePrefix) === 0) {
			return cookie.substring(cookiePrefix.length, cookie.length);
		}
	}
	return '';
}

export function setCookie(name, value, time) {
	const date = new Date();
	date.setTime(date.getTime() + 24 * time * 60 * 60 * 1e3);
	document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/;`;
}
